module.exports = __webpack_public_path__ + "0ead19bf7ffe51d0b703e0734a753605.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/misc/text-to-speech.png
// module id = 308
// module chunks = 0